import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import "./assets/reset.less"
import naive from 'naive-ui'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import store from './store'
import { isMsalPopup } from './utils/msalEnv'




if (isMsalPopup()) {
  // MSAL 登录弹窗只负责承载回调地址和 hash，登录由父窗口完成。
  // 部分平板/Edge 浏览器不会自动关闭弹窗，这里做兜底：检测到父窗口登录完成就自动关闭，
  // 关不掉时再把当前窗口顶到应用页，最后才让用户点“返回应用”。
  const popupStartAt = Date.now()
  const root = document.getElementById('app')
  if (root) {
    root.innerHTML = [
      '<div style="padding:40px;text-align:center;color:#666;font-size:14px;">',
      '<div>登录中，请稍候…</div>',
      '<div id="msal-popup-hint" style="display:none;margin-top:16px;color:#999;font-size:12px;">登录已完成，如果页面没有自动关闭，请点击下面的按钮</div>',
      '<button id="msal-popup-close" style="display:none;margin-top:12px;padding:8px 16px;border:1px solid #09a3a3;background:#fff;color:#09a3a3;border-radius:4px;font-size:14px;">返回应用</button>',
      '</div>',
    ].join('')
    const returnToApp = () => {
      // 先尝试关闭弹窗；部分平板浏览器会禁止脚本关窗
      try { window.close() } catch (_) {}
      window.setTimeout(() => {
        try {
          const opener = window.opener as Window | null
          if (!opener || opener.closed) return
          if (opener.location.pathname !== '/homepage') {
            try { window.history.back() } catch (_) {}
            return
          }
          // 关不掉时：把主窗口最新登录态复制过来，让当前窗口直接变成应用窗口
          for (let i = 0; i < opener.sessionStorage.length; i++) {
            const key = opener.sessionStorage.key(i)
            if (key) {
              window.sessionStorage.setItem(key, opener.sessionStorage.getItem(key) || '')
            }
          }
          const target = (opener.location.pathname || '/homepage') +
            (opener.location.search || '') +
            (opener.location.hash || '')
          window.name = ''
          window.opener = null
          window.location.replace(target || '/homepage')
        } catch (_) {
          try { window.history.back() } catch (_) {}
        }
      }, 300)
    }
    document.getElementById('msal-popup-close')?.addEventListener('click', returnToApp)
    window.setTimeout(() => {
      const hint = document.getElementById('msal-popup-hint')
      const button = document.getElementById('msal-popup-close')
      if (hint) hint.style.display = 'block'
      if (button) button.style.display = 'inline-block'
    }, 3000)
    // 父窗口是否已完成登录。
    // localStorage 标记由父窗口登录成功后写入，跨标签页可靠且不受 COOP 限制；
    // 仅依赖 opener.closed / opener.location 在 Edge 上会读不到（会被判定为已关闭），导致弹窗一直不关。
    const parentLoggedIn = () => {
      try {
        const doneAt = Number(window.localStorage.getItem('aad-login-done') || 0)
        if (doneAt && doneAt >= popupStartAt) return true
      } catch (_) {}
      // 主窗口已改用整页跳转登录：本弹窗已无意义，直接关闭
      try {
        const fallbackAt = Number(window.localStorage.getItem('aad-redirect-fallback') || 0)
        if (fallbackAt && fallbackAt >= popupStartAt) {
          try { window.close() } catch (_) {}
          return false
        }
      } catch (_) {}
      try {
        const opener = window.opener as Window | null
        if (!opener) return false
        if (opener.sessionStorage.getItem('token')) return true
        if (opener.location.pathname === '/homepage') return true
      } catch (_) {}
      return false
    }
    window.addEventListener('storage', (event) => {
      if (event.key === 'aad-login-done' && parentLoggedIn()) returnToApp()
    })
    const closeTimer = window.setInterval(() => {
      if (parentLoggedIn()) {
        window.clearInterval(closeTimer)
        returnToApp()
      }
    }, 600)
    // 兜底：回调页已经停留一段时间仍读不到父窗口状态，也尝试回到应用（关不掉时不影响父窗口登录）
    window.setTimeout(() => {
      if (parentLoggedIn()) {
        window.clearInterval(closeTimer)
        returnToApp()
      }
    }, 8000)
  }
} else {
  createApp(App).use(router).use(store).use(naive).use(ElementPlus).mount('#app')
}
